function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.768 7.607a2.5 2.5 0 11-3.536 3.536 2.5 2.5 0 013.536-3.536z",
  fill: "#879097"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 2.5h-1.727L14.522 0H5.477l-1.25 2.501-1.725.003a2.505 2.505 0 00-2.495 2.5L0 15c0 1.379 1.121 2.5 2.5 2.5h15c1.379 0 2.5-1.12 2.5-2.5V5c0-1.379-1.121-2.5-2.5-2.5zM10 14.375c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z",
  fill: "#879097"
});

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCamera;